import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";
import { SITE } from "@/config/site";

// Fil d'Ariane + données structurées BreadcrumbList.
export const Breadcrumbs = ({ items = [] }) => {
  const all = [{ label: "Accueil", to: "/" }, ...items];
  return (
    <nav aria-label="Fil d'Ariane" data-testid="breadcrumbs" className="text-sm">
      <ol className="flex items-center flex-wrap gap-1.5 text-brand-text">
        {all.map((it, i) => {
          const last = i === all.length - 1;
          return (
            <li key={i} className="flex items-center gap-1.5">
              {i > 0 && <ChevronRight className="w-3.5 h-3.5 opacity-50" />}
              {last || !it.to ? (
                <span className="font-semibold text-brand-black" aria-current="page">
                  {it.label}
                </span>
              ) : (
                <Link to={it.to} className="hover:text-brand-black inline-flex items-center gap-1">
                  {i === 0 && <Home className="w-3.5 h-3.5" />} {it.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [{ label: "Accueil", to: "/" }, ...items].map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.label,
    item: SITE.url + (it.to || ""),
  })),
});
